import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { useEffect } from "react";
import { Route, Switch, useLocation, useParams } from "wouter";
import { AppRoleRoutes } from "./app-role/app-role.routes";
import { ApplicationCreateView } from "./application-create.view";
import { ApplicationUpdateView } from "./application-uuid-update.view";
import { ApplicationView } from "./application.view";

function ApplicationUuidRedirect() {
  const params = useParams<{ applicationUuid: string }>();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (!params.applicationUuid) return;
    navigate(`/${params.applicationUuid}/app-role`, { replace: true });
  }, [navigate, params.applicationUuid]);

  return null;
}

export function ApplicationRoutes() {
  const applicationUuidAppRoleRegex = generateUuidV4Regex({
    paramName: "applicationUuid",
    suffix: "/app-role",
    allowTrailing: true,
  });
  const applicationUuidUpdateRegex = generateUuidV4Regex({ paramName: "applicationUuid", suffix: "/update" });
  const applicationUuidRegex = generateUuidV4Regex({ paramName: "applicationUuid" });

  return (
    <Switch>
      <Route path={"/create"} component={ApplicationCreateView} />
      <Route nest path={applicationUuidAppRoleRegex} component={AppRoleRoutes} />
      <Route path={applicationUuidUpdateRegex} component={ApplicationUpdateView} />
      <Route path={applicationUuidRegex} component={ApplicationUuidRedirect} />
      <Route path={"/"} component={ApplicationView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
